import React from 'react';

const NavigazioneTabs = ({ activeTab, setActiveTab, isOfferteTabDisabled }) => {
  return (
    <div className="flex space-x-1">
      <button 
        onClick={() => setActiveTab('riepilogo')}
        className={`px-4 py-2 rounded-t-lg text-sm font-medium ${
          activeTab === 'riepilogo' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        RIEPILOGO
      </button>
      <button 
        onClick={() => setActiveTab('anagrafica')}
        className={`px-4 py-2 rounded-t-lg text-sm font-medium ${
          activeTab === 'anagrafica' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        ANAGRAFICA
      </button>
      <button 
        onClick={() => !isOfferteTabDisabled() && setActiveTab('offerte')}
        disabled={isOfferteTabDisabled()}
        className={`px-4 py-2 rounded-t-lg text-sm font-medium transition-colors ${
          isOfferteTabDisabled()
            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
            : activeTab === 'offerte' 
              ? 'bg-blue-600 text-white' 
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
        title={isOfferteTabDisabled() ? 'Tab disabilitata durante l\'attesa del preventivo' : ''}
      >
        OFFERTE
      </button>
      <button 
        onClick={() => setActiveTab('preventivi')}
        className={`px-4 py-2 rounded-t-lg text-sm font-medium ${
          activeTab === 'preventivi' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        PREVENTIVI
      </button>
      <button 
        onClick={() => setActiveTab('documenti')}
        className={`px-4 py-2 rounded-t-lg text-sm font-medium ${
          activeTab === 'documenti' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        DOCUMENTI
      </button>
      <button 
        onClick={() => setActiveTab('comunicazioni')}
        className={`px-4 py-2 rounded-t-lg text-sm font-medium ${
          activeTab === 'comunicazioni' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        COMUNICAZIONI
      </button>
      <button 
        onClick={() => setActiveTab('contratti')}
        className={`px-4 py-2 rounded-t-lg text-sm font-medium ${
          activeTab === 'contratti' 
            ? 'bg-blue-600 text-white' 
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        CONTRATTI
      </button>
    </div>
  );
};

export default NavigazioneTabs; 